<template>
  <div id="paymentBlur">
    <p>
      {{ $t('component.blur.notSubscribed') }}
    </p>
    <div class="buttonWrap">
      <el-button
        type="primary"
        round
        @click="openLink"
      >
        {{ $t('component.blur.updatePayment') }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlurPayment',

  methods: {
    openLink() {
      let url = 'https://gcgroup-test.chargebeeportal.com/portal/v2/login?forward=home';
      if (process.env.VUE_APP_ENV === 'prod') {
        url = 'https://gcgroup.chargebeeportal.com/';
      }
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
  #paymentBlur {
    p {
      word-break: break-word;
    }

    .buttonWrap {
      width: 100%;
      padding: 10px 0 0;
      display: flex;
      justify-content: center;
    }
  }
</style>
